import _ from "lodash";

import { concatStrings } from "../../lib/utility";

export const Metadata = ({ value }: { value: string }) => {
  const metadata: Record<string, string | null | undefined> = JSON.parse(value);

  return (
    // Metadata container
    <div className="flex flex-col">
      {/* Map each metadata */}
      {_(metadata)
        .map((value, key) => {
          return (
            <div key={key} className="flex flex-row">
              {concatStrings([key, value], ": ")}
            </div>
          );
        })
        .value()}
    </div>
  );
};
